import { createWorkWeekDaysArray } from 'owa-datetime-utils';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { SurfaceUserOptions, DEFAULT_WORKWEEKDAYS } from 'owa-calendar-surface-core';

/**
 * Creates surface user options
 */
export default function getOwaDayGridOptions(): SurfaceUserOptions {
    let userConfiguration = getUserConfiguration();
    let userOptions = userConfiguration.UserOptions;

    return {
        isRTL: userConfiguration.SessionSettings.IsUserCultureRightToLeft,
        weekStartDay: userOptions.WeekStartDay,
        hourIncrement: userOptions.HourIncrement,
        showWeekNumbers: userOptions.ShowWeekNumbers,
        firstWeekOfYear: userOptions.FirstWeekOfYear as any,
        workHoursStartTimeInMinutes: userOptions.WorkingHours.WorkHoursStartTimeInMinutes,
        workHoursEndTimeInMinutes: userOptions.WorkingHours.WorkHoursEndTimeInMinutes,
        workDays: userOptions.WorkingHours.WorkDays
            ? createWorkWeekDaysArray(userOptions.WorkingHours.WorkDays)
            : createWorkWeekDaysArray(DEFAULT_WORKWEEKDAYS),
    };
}
